import React from 'react';
import { Tooltip } from 'antd';
import styled from 'styled-components';
import LinkButton from '../LinkButton';
import { useEntityData, useRefetch } from '../../../../EntityContext';
import { AddLinkModal } from '../../../../components/styled/AddLinkModal';
import { mapLinkToLinkType } from '../../../../utils';
import { useTranslation } from '../../../../../../../i18n/useTranslation';

interface Props {
    hideLinksButton?: boolean;
    readOnly?: boolean;
    /** When provided, used for Add Link button (RBAC). */
    editLinksDisabled?: boolean;
    editLinksTooltip?: string;
}

const TooltipWrapper = styled.span<{ isReadOnly?: boolean }>`
    display: inline-block;
    cursor: ${(props) => (props.isReadOnly ? 'not-allowed' : 'pointer')};
`;

export default function LinksSection({ hideLinksButton, readOnly, editLinksDisabled, editLinksTooltip }: Props) {
    const { entityData } = useEntityData();
    const refetch = useRefetch();
    const { t } = useTranslation();
    const links = entityData?.institutionalMemory?.elements || [];

    const existingLinks = mapLinkToLinkType(links);
    const isAddLinkDisabled = editLinksDisabled ?? readOnly;
    const addLinkTooltip = editLinksTooltip ?? (readOnly ? t('ASSET_MARKED_AS_READ_ONLY') : undefined);

    return (
        <>
            {links.map((link) => (
                <div className="mb-2">
                    <LinkButton link={link} />
                </div>
            ))}
            {!hideLinksButton && (
                <Tooltip title={addLinkTooltip} overlayClassName="f-tooltip-white">
                    <TooltipWrapper isReadOnly={isAddLinkDisabled}>
                        <AddLinkModal
                            buttonProps={{ type: 'default', disabled: isAddLinkDisabled }}
                            refetch={refetch}
                            existingLinks={existingLinks}
                        />
                    </TooltipWrapper>
                </Tooltip>
            )}
        </>
    );
}
